enum CheckoutPaymentMethod {
  TICKET = "ticket",
  CC = "cc",
  TRANSFER = "transfer",
  MP_CC = "mp-cc",
  MP_DC = "mp-dc",
  MP_BANK_TRANSFER = "mp-bank-transfer",
  MP_TICKET = "mp-ticket",
  MP_BOLETO = "mp-boleto",
}

export default CheckoutPaymentMethod;
